// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"647b74c5","879":"d8983c1e"}[chunkId] + ".chunk.js";
};